export default __webpack_public_path__ + "static/media/avatar_fairy_pixie5.b962b7b9.mp3";